var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModaldownloadicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#F9FAFB",
    strokeWidth: 8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8953 18.1271C28.8953 17.5046 28.3907 17 27.7682 17C27.1457 17 26.6411 17.5046 26.6411 18.1271V28.1799L24.0568 25.5955C23.6166 25.1554 22.903 25.1554 22.4628 25.5955C22.0227 26.0357 22.0227 26.7493 22.4628 27.1895L26.9712 31.6979C27.4114 32.1381 28.1251 32.1381 28.5652 31.6979L33.0736 27.1895C33.5138 26.7493 33.5138 26.0357 33.0736 25.5955C32.6335 25.1554 31.9198 25.1554 31.4797 25.5955L28.8953 28.1799V18.1271Z",
    fill: "#3E444C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5365 32.4037C37.5365 31.7813 37.0318 31.2766 36.4094 31.2766C35.7869 31.2766 35.2823 31.7813 35.2823 32.4037V33.606C35.2823 34.2285 34.7776 34.7331 34.1551 34.7331H21.3813C20.7588 34.7331 20.2542 34.2285 20.2542 33.606L20.2542 32.4037C20.2542 31.7813 19.7496 31.2766 19.1271 31.2766C18.5046 31.2766 18 31.7813 18 32.4037V33.606C18 35.4734 19.5139 36.9873 21.3813 36.9873L34.1551 36.9873C36.0226 36.9873 37.5365 35.4734 37.5365 33.606V32.4037Z",
    fill: "#3E444C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgModaldownloadicon);
export default __webpack_public_path__ + "static/media/modaldownloadicon.eb2fed4cfa88fe0582eaee29627f0525.svg";
export { ForwardRef as ReactComponent };